import { useContext, useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import CreateOrderContext from "../../context/createOrder/";
import { usePrices } from "../../context/prices/PricesContext";
import RegelBedrag, { RegelAantal } from "./RegelBedrag";

/**
 * Stootborden: standaard (zelfde materiaal en kleur als de treden) of een los
 * speciaal product.
 *
 * Het aantal en de prijs worden niet meer hier berekend — dat doet de backend.
 * Deze component legt alleen de keuze vast.
 */
const Risers = () => {
  const { risersMode, specialRiserId, stairMaterial, stairColor } =
    useContext(CreateOrderContext);

  const { getMaterialName, specialRisers } = usePrices();

  const speciaal = risersMode.value === "speciaal";
  const regelCode = speciaal ? "stootborden-speciaal" : "stootborden";

  const selectedSpecial =
    specialRisers.find((r) => r.id === specialRiserId.value) ?? null;

  // Bij het overschakelen naar "speciaal" alvast het eerste product kiezen,
  // zodat de calculatie iets te rekenen heeft.
  useEffect(() => {
    if (speciaal && !specialRiserId.value && specialRisers.length > 0) {
      specialRiserId.set(specialRisers[0].id);
    }
    if (!speciaal && specialRiserId.value) {
      specialRiserId.set(null);
    }
    // eslint-disable-next-line
  }, [speciaal, specialRisers.length]);

  return (
    <>
      <Row className="mb-2">
        <Col xs={12}>
          <Form.Label style={{ fontWeight: 600 }}>Stootborden</Form.Label>
        </Col>
        <Col
          xs={12}
          className="mb-2"
          style={{ display: "flex", gap: 24, flexWrap: "wrap" }}
        >
          <Form.Check
            type="radio"
            id="risers-mode-standard"
            name="risersMode"
            label="Zelfde als treden"
            checked={!speciaal}
            onChange={() => risersMode.set("standaard")}
          />
          <Form.Check
            type="radio"
            id="risers-mode-special"
            name="risersMode"
            label="Speciale stootborden"
            checked={speciaal}
            onChange={() => risersMode.set("speciaal")}
          />
        </Col>
      </Row>

      {!speciaal ? (
        <Row>
          <Form.Group as={Col} xs={6} md={3} className="auth-input ">
            <Form.Label>Materiaal</Form.Label>
            <Form.Control
              type={"text"}
              disabled={true}
              value={getMaterialName(stairMaterial.value)}
            />
          </Form.Group>

          <Form.Group as={Col} xs={6} md={3} className="auth-input ">
            <Form.Label>Kleur</Form.Label>
            <Form.Control
              type={"text"}
              disabled={true}
              value={stairColor.value || "—"}
            />
          </Form.Group>

          <RegelAantal code={regelCode} />
          <RegelBedrag code={regelCode} />
        </Row>
      ) : (
        <>
          <Row>
            <Form.Group as={Col} xs={12} md={6} className="auth-input ">
              <Form.Label>Speciaal stootbord</Form.Label>
              <select
                className="select"
                style={{ padding: "8px 4px", position: "inherit" }}
                value={specialRiserId.value ?? ""}
                onChange={(e) => specialRiserId.set(e.target.value || null)}
              >
                {specialRisers.length === 0 && (
                  <option value="">Geen speciale stootborden beschikbaar</option>
                )}
                {specialRisers.map((r) => (
                  <option key={r.id} value={r.id} className="select-item">
                    {r.name}
                  </option>
                ))}
              </select>
            </Form.Group>

            <RegelAantal code={regelCode} />
            <RegelBedrag code={regelCode} />
          </Row>

          {selectedSpecial?.description && (
            <Row className="mb-2">
              <Col xs={12}>
                <span style={{ color: "#6c757d", fontSize: "0.85rem" }}>
                  {selectedSpecial.description}
                </span>
              </Col>
            </Row>
          )}

          {selectedSpecial?.imageUrl && (
            <Row className="mb-3">
              <Col xs={6} md={3}>
                <img
                  src={selectedSpecial.imageUrl}
                  alt={selectedSpecial.name}
                  style={{
                    maxHeight: 70,
                    maxWidth: "100%",
                    objectFit: "contain",
                    border: "1px solid #e2e8f0",
                    borderRadius: 4,
                    padding: 2,
                  }}
                />
              </Col>
            </Row>
          )}
        </>
      )}
    </>
  );
};

export default Risers;
